import { ReactNode } from 'react';
import { Box } from '@gemini/core';
import { TStyleProps } from '@mfe-types/box';

interface IFieldsetWrapper {
    legendTitle: string;
    styles?: TStyleProps;
    children: ReactNode;
    name: string;
}

const FieldsetWrapper = ({ legendTitle, styles, children, name }: IFieldsetWrapper) => {
    return (
        <Box
            as="fieldset"
            testId={`fieldset-${name}`}
            borderWidth="borderWidth.none"
            padding="spacing.none"
            margin="spacing.none"
            minWidth="0"
            {...styles}
        >
            <Box as="legend" visibility="hidden" height="0" width="0" padding="spacing.none">
                {legendTitle}
            </Box>
            {children}
        </Box>
    );
};

export default FieldsetWrapper;
